import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import ServicesHero from './components/ServicesHero';
import StepsSection from './components/StepsSection';
import ProcessTimeline from './components/ProcessTimeline';
import { useSEO, generateOrganizationSchema, generateWebPageSchema } from '../../utils/seo';

export default function ServicesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';
  
  const schemas = [
    generateOrganizationSchema(),
    generateWebPageSchema(
      'Nos Services - LED 1€',
      'Découvrez nos services complets de rénovation LED à Paris : audit énergétique, étude photométrique, installation certifiée et gestion CEE. Un accompagnement sur mesure pour votre projet d\'éclairage professionnel.',
      `${siteUrl}/nos-services`
    )
  ];

  useSEO({
    title: 'Nos Services - LED 1€ | POWERENO',
    description: 'Découvrez nos services complets de rénovation LED à Paris : audit énergétique, étude photométrique, installation certifiée et gestion CEE. Un accompagnement sur mesure pour votre projet d\'éclairage professionnel.',
    keywords: 'services LED Paris, audit éclairage, installation LED certifiée, gestion CEE, rénovation LED professionnelle',
    canonical: `${siteUrl}/nos-services`,
    schema: schemas
  });

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="bg-white">
        <Navbar />
        <ServicesHero />
        <StepsSection />
        <ProcessTimeline />
        <FloatingCTA />
        <Footer />
      </div>
    </Suspense>
  );
}
